import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "../../utils/axiosConfig";
import "./AccessoryComponent.css";

function AccessoryComponent() {
  const [accessories, setAccessories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState({ type: "", text: "" });
  const navigate = useNavigate();

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      setLoading(true);
      const res = await axios.get("/accessories-with-config-count");
      setAccessories(res.data.data || []);
    } catch (error) {
      setMessage({
        type: "error",
        text: error.response?.data?.message || "Failed to load component types",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="acc-comp-container">
      <div className="acc-comp-header">
        <div>
          <h1 className="acc-comp-title">Accessory Component Master</h1>
          <p className="acc-comp-subtitle">
            Manage model configurations for each component type
          </p>
        </div>
      </div>

      {message.text && (
        <div className={`alert-message alert-${message.type}`}>{message.text}</div>
      )}

      {loading ? (
        <div className="loading-container">Loading component types...</div>
      ) : (
        <div className="table-card">
          <div className="table-responsive">
            <table className="acc-comp-table">
              <thead>
                <tr>
                  <th>Component Type</th>
                  <th>No. of Configurations</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {accessories.length === 0 ? (
                  <tr>
                    <td colSpan="3" className="no-data-row">
                      No component types found. Please add accessories in{" "}
                      <button
                        className="link-btn"
                        onClick={() => navigate("/admin/accessories-config")}
                      >
                        Accessories Configuration Master
                      </button>
                    </td>
                  </tr>
                ) : (
                  accessories.map((acc) => (
                    <tr key={acc.id}>
                      <td className="acc-name-cell">{acc.name}</td>
                      <td>
                        <span className="config-count-badge">
                          {acc.configuration_count}
                        </span>
                      </td>
                      <td>
                        <button
                          className="btn-manage"
                          onClick={() =>
                            navigate(
                              `/admin/accessory-component/${acc.id}/configurations`
                            )
                          }
                        >
                          Manage →
                        </button>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
}

export default AccessoryComponent;
